import { USER_TYPES } from './user';
import { BOOKING_TYPES } from './booking';

export const TICKET_TYPES = {
  EMAIL: 'EMAIL',
  PDF: 'PDF',
  ATB: 'ATB',
  QR: 'QR'
};

export const TICKET_PASSPORT_REQUIREMENTS = new Map();

TICKET_PASSPORT_REQUIREMENTS.set(
  {
    user: USER_TYPES.STATION_USER,
    booking: BOOKING_TYPES.GENERAL,
    ticket: TICKET_TYPES.EMAIL
  },
  false
);

TICKET_PASSPORT_REQUIREMENTS.set(
  {
    user: USER_TYPES.STATION_USER,
    booking: BOOKING_TYPES.GENERAL,
    ticket: TICKET_TYPES.PDF
  },
  false
);

TICKET_PASSPORT_REQUIREMENTS.set(
  {
    user: USER_TYPES.STATION_USER,
    booking: BOOKING_TYPES.GENERAL,
    ticket: TICKET_TYPES.ATB
  },
  false
);

TICKET_PASSPORT_REQUIREMENTS.set(
  {
    user: USER_TYPES.STATION_USER,
    booking: BOOKING_TYPES.GENERAL,
    ticket: TICKET_TYPES.QR
  },
  false
);

TICKET_PASSPORT_REQUIREMENTS.set(
  {
    user: USER_TYPES.STATION_USER,
    booking: BOOKING_TYPES.ACCESSIBLE_TRAVEL,
    ticket: TICKET_TYPES.EMAIL
  },
  false
);

TICKET_PASSPORT_REQUIREMENTS.set(
  {
    user: USER_TYPES.STATION_USER,
    booking: BOOKING_TYPES.ACCESSIBLE_TRAVEL,
    ticket: TICKET_TYPES.ATB
  },
  false
);

TICKET_PASSPORT_REQUIREMENTS.set(
  {
    user: USER_TYPES.STATION_USER,
    booking: BOOKING_TYPES.PACKAGE,
    ticket: TICKET_TYPES.EMAIL
  },
  false
);

TICKET_PASSPORT_REQUIREMENTS.set(
  {
    user: USER_TYPES.STATION_USER,
    booking: BOOKING_TYPES.PACKAGE,
    ticket: TICKET_TYPES.PDF
  },
  false
);

TICKET_PASSPORT_REQUIREMENTS.set(
  {
    user: USER_TYPES.STATION_USER,
    booking: BOOKING_TYPES.PACKAGE,
    ticket: TICKET_TYPES.ATB
  },
  false
);

TICKET_PASSPORT_REQUIREMENTS.set(
  {
    user: USER_TYPES.STATION_USER,
    booking: BOOKING_TYPES.PACKAGE,
    ticket: TICKET_TYPES.QR
  },
  false
);

TICKET_PASSPORT_REQUIREMENTS.set(
  {
    user: USER_TYPES.ANY_OTHER_ES_USER,
    booking: BOOKING_TYPES.GENERAL,
    ticket: TICKET_TYPES.EMAIL
  },
  false
);

TICKET_PASSPORT_REQUIREMENTS.set(
  {
    user: USER_TYPES.ANY_OTHER_ES_USER,
    booking: BOOKING_TYPES.GENERAL,
    ticket: TICKET_TYPES.PDF
  },
  false
);

TICKET_PASSPORT_REQUIREMENTS.set(
  {
    user: USER_TYPES.ANY_OTHER_ES_USER,
    booking: BOOKING_TYPES.ACCESSIBLE_TRAVEL,
    ticket: TICKET_TYPES.EMAIL
  },
  false
);

TICKET_PASSPORT_REQUIREMENTS.set(
  {
    user: USER_TYPES.ANY_OTHER_ES_USER,
    booking: BOOKING_TYPES.ACCESSIBLE_TRAVEL,
    ticket: TICKET_TYPES.PDF
  },
  false
);

TICKET_PASSPORT_REQUIREMENTS.set(
  {
    user: USER_TYPES.ANY_OTHER_ES_USER,
    booking: BOOKING_TYPES.PACKAGE,
    ticket: TICKET_TYPES.EMAIL
  },
  false
);

TICKET_PASSPORT_REQUIREMENTS.set(
  {
    user: USER_TYPES.ANY_OTHER_ES_USER,
    booking: BOOKING_TYPES.PACKAGE,
    ticket: TICKET_TYPES.PDF
  },
  false
);

TICKET_PASSPORT_REQUIREMENTS.set(
  {
    user: USER_TYPES.TRAVEL_AGENT,
    booking: BOOKING_TYPES.GENERAL,
    ticket: TICKET_TYPES.EMAIL
  },
  true
);

TICKET_PASSPORT_REQUIREMENTS.set(
  {
    user: USER_TYPES.TRAVEL_AGENT,
    booking: BOOKING_TYPES.GENERAL,
    ticket: TICKET_TYPES.PDF
  },
  true
);

TICKET_PASSPORT_REQUIREMENTS.set(
  {
    user: USER_TYPES.TRAVEL_AGENT,
    booking: BOOKING_TYPES.ACCESSIBLE_TRAVEL,
    ticket: TICKET_TYPES.EMAIL
  },
  true
);

TICKET_PASSPORT_REQUIREMENTS.set(
  {
    user: USER_TYPES.TRAVEL_AGENT,
    booking: BOOKING_TYPES.ACCESSIBLE_TRAVEL,
    ticket: TICKET_TYPES.PDF
  },
  true
);

TICKET_PASSPORT_REQUIREMENTS.set(
  {
    user: USER_TYPES.TRAVEL_AGENT,
    booking: BOOKING_TYPES.PACKAGE,
    ticket: TICKET_TYPES.PDF
  },
  true
);

TICKET_PASSPORT_REQUIREMENTS.set(
  {
    user: USER_TYPES.TRAVEL_AGENT,
    booking: BOOKING_TYPES.GROUP,
    ticket: TICKET_TYPES.EMAIL
  },
  true
);
